"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSubstringIndexRanges = void 0;
const getSubstringIndexRanges = (searchTerms, text) => {
  const foundTermsIndexRanges = [];
  searchTerms.forEach(searchTerm => {
    if (searchTerm) {
      const startIndex = text.toLowerCase().indexOf(searchTerm.toLowerCase());
      if (startIndex >= 0) {
        foundTermsIndexRanges.push([startIndex, startIndex + searchTerm.length]);
      }
    }
  });
  return foundTermsIndexRanges;
};
exports.getSubstringIndexRanges = getSubstringIndexRanges;